<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="box">
            <div  class="columns ">
                <div  class="column is-2">                
                    <b-field>
                        <b-input :placeholder="$t('SISTEMA.CODIGO')"
                                v-model="codigoExterno"
                                type="number"
                                    icon="magnify"
                                @input="loadAsyncData()">
                        </b-input>
                    </b-field>                
                </div>            
            <div class="column is-3">
                <b-field>
                    <b-input :placeholder="$t('GUIALIST.BUSCARGUIASNOME')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData()"></b-input>
                </b-field>
            </div>            


            <div  class="column is-3">
                <b-field>
                    <b-select  v-model="vendedorFiltro" :placeholder="$t('GUIALIST.VENDEDOR')"  @input="loadAsyncData()" expanded>
                        <option :value="null"></option>
                        <template v-for="(item, index) in this.listaVendedoresUnidade">
                            <option v-if="vendedorFiltro == item.id" selected v-bind:key="index" :value="item.id">
                                {{item.nome}}
                            </option>
                            <option v-else v-bind:key="index" :value="item.id">
                                {{item.nome}}
                            </option>
                        </template>
                    </b-select>              
                </b-field>
            </div>  
            <div  class="column is-3">
                <b-field>
                    <b-select  v-model="temperaturaFiltro" :placeholder="$t('GUIALIST.TEMPERATURA')"  @input="loadAsyncData()" expanded>                        
                        <option :value="null"></option>
                        <option value="1">FRIO</option>
                        <option value="2">MORNO</option>
                        <option value="3">QUENTE</option>                        
                    </b-select>              
                </b-field>
            </div>  

        </div>
            
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                  :bordered="true"
                 :paginated="false"
                 striped
                 hoverable
                 backend-pagination                 
                 @page-change="onPageChange"
                 :aria-next-label="$t('SISTEMA.PROXPAGINA')"
                 :aria-previous-label="$t('SISTEMA.PAGINAANTERIOR')"
                 :aria-page-label="$t('SISTEMA.PAGINA')"
                 :aria-current-label="$t('SISTEMA.PAGINAATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"                 
                 @sort="onSort"
                 class="float-header">

            <template >
                <b-table-column  v-slot="props" field="Id" :label="$t('SISTEMA.CODIGO')"  >


                    {{ props.row.clienteCodigoExterno }}


                    <span >   
                        <b-icon v-if="props.row.urgente"
                                icon="bookmark" 
                                size="is-small" 
                                 :title="$t('GUIALIST.URGENCIA')"
                                class="bookmark-custom-style"></b-icon>  
                        <b-icon v-if="props.row.dataHoraBloqueado !=null"
                                        icon="account-alert"
                                        size="is-small"                                    
                                        :title="$t('GUIALIST.CLIENTEEMESPERA')"
                                        type="is-warning"></b-icon>                                                
                                 
                    </span>                                                                                                                                                                                           
                </b-table-column>


                <b-table-column   v-slot="props" field="ClienteNome" :label="$t('SISTEMA.CLIENTE')" sortable  >                    
                        {{ props.row.clienteNome }}   
                        <span>                                                              
                            <a class="has-text-info" @click="verStatusAtual(props.row,false)" :title="$t('GUIALIST.VERSTATUS')">
                                <b-icon  icon="eye" size="is-small"></b-icon>
                            </a>                                 
                        </span>                                                                          
                </b-table-column>                
    
                

                <b-table-column   v-slot="props" field="Temperatura" :label="$t('GUIALIST.TEMPERATURA2')"  sortable >
                    <span class="is-size-7">
                        <span v-if="props.row.temperatura >0" class="cp ml-2 tag is-light">
                                <b v-if="props.row.temperatura == 1" :title="$t('GUIALIST.FRIO')" class="has-text-info">F</b> 
                                <b v-else-if="props.row.temperatura == 2" :title="$t('GUIALIST.MORNO')" class="has-text-warning">M</b> 
                                <b v-else-if="props.row.temperatura == 3" :title="$t('GUIALIST.QUENTE')" class="has-text-danger">Q</b>                       
                        </span> 
                        <span v-else>
                          
                        </span>                         

                    </span>
                </b-table-column>                       
                <b-table-column   v-slot="props" field="VendedorNome" :label="$t('GUIALIST.VENDEDOR')"  >
                    <span v-if="props.row.funcionarioComercialNome">
                        <p class="is-size-7 columns-nowrap-10" :title="props.row.funcionarioComercialNome.toUpperCase()"> {{ props.row.funcionarioComercialNome.toUpperCase() }}</p>
                    </span>
                    <span v-else></span>
                    
                </b-table-column>
                <b-table-column    v-slot="props" field="ArquitetoNome" :label="$t('GUIALIST.ARQUITETO')"  >
                    <span v-if="props.row.clienteArquiteto">
                        <p class="is-size-7 columns-nowrap-10" :title="props.row.clienteArquiteto">{{ props.row.clienteArquiteto }}</p>
                    </span>
                    <span v-else></span>                    
                    
                </b-table-column> 
                         


                <b-table-column  v-slot="props" custom-key="actions" numeric >

                    <span >                        

                        <b-button @click="abrirModalFinalizarOportunidade(props.row)" class="is-small  ml-2"> 
                            <b-icon icon="check-bold" size="is-small"></b-icon>
                        </b-button>                                                                                                                                                                                                                                                                                                                                                                         
                    </span>
                       
                </b-table-column>
                
            </template>
            <template #footer >
                <th >
                    <div class="th-wrap is-numeric">  </div>
                </th>
                <th > <div class="th-wrap is-size-7"> {{ model.lista.length }} registro(s)  </div> </th>      
                <th > <div class="th-wrap"> </div> </th>        
                <th > <div class="th-wrap"> </div> </th>                                                              
                <th > <div class="th-wrap"> </div> </th>                
                <th > <div class="th-wrap"> </div> </th>                

            </template>              
                      
        </b-table>

        <nav class="level">
                <div class="level-item">
                    <p class="buttons">
                        <b-button type="is-danger"
                                  native-type="button"
                                  icon-left="close-circle"
                                  @click="$router.back();">
                            {{$t('SISTEMA.VOLTAR')}}
                        </b-button>
                         
                    </p>
                </div>
            </nav>        
    </section>
</template>



<style scoped>
    .has-background-dark {
        background-color: #363636d6 !important;
    }


</style>

<script>
    import titlebar from '@/components/titlebar.vue'
    import debounce from 'lodash/debounce'    
    import modalVerStatusAtualGuia from '@/components/atendimento/modalVerStatusAtualGuia.vue'    
    import modalObservacaoOportunidadeInside from '@/components/atendimento/modalObservacaoOportunidadeInside.vue'  


    import { mapState, mapGetters } from 'vuex'

    export default {
        data(){
            return {
                model: [],
                loading: false,                
                ordenarPor: '',
                ordenar: '',
                defaultOrdenar: '',
                page: 1,
                perPage: 20,                
                id: null,
                codigoExterno:null,
                procurar: null,
                
                listaVendedoresUnidade:[],                
                vendedorFiltro:null,
                temperaturaFiltro:null,
                dataFiltro: 'cadastro',                         
            }
        },
        components: {
            titlebar,
            
        },
        computed: {
            titleStack() {
                return [
                    this.$t('SISTEMA.ATENDIMENTO'),   this.$t('ATENDIMENTO.OPORTUNIDADEINSIDE'),                    
                ]
            },
            ...mapState([
                'unidadeId',
                'usuario'
            ]),
            ...mapGetters([
                'isInRole'
            ])            
        },
        watch: {            
            unidadeId: function(novaUnidade) {                 
                this.loadAsyncData();
                this.filtroTodos = false;                                                
            },
            datas: function() {                 
                this.loadAsyncData()                                                                
            },
            dataFiltro: function() {                 
                this.loadAsyncData();                
            },            
        },         
        methods: { 


            abrirModalFinalizarOportunidade(guia){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalObservacaoOportunidadeInside,
                    props: {
                        id: guia.id
                    },
                    events: {
                        loadData: this.loadAsyncData
                    },
                    hasModalCard: true,
                    trapFocus: true
                })
            },            
     
            verStatusAtual(guia,mensagemBloqueio){  

                this.$http.get(`/api/atendimento/VerStatusAtual?id=${guia.id}`)
                .then(res => res.data)
                .then(data => {

                    this.$buefy.modal.open({
                        parent: this,
                        component: modalVerStatusAtualGuia,
                        props: {
                            processo: data.processo,
                            etapa: data.etapa,
                            clienteNome: guia.clienteNome                      
                        },
                        events: {                                                
                            encontrarCliente: this.encontrarCliente,
                        },
                        hasModalCard: true,
                        trapFocus: true
                    })                    

     
                });                             
                return;                
                
            },       

           
            isVendedor(){                
                return this.usuario.nivel == 'Vendedor' || this.usuario.nivel.includes('Vendedor');
            },      
                
                     
            loadAsyncData: debounce(function () {

                const params = this.montaParametros();
                    
                this.loading = true;

                                    
                this.$http.get(`/api/atendimento/ProcurarEmNegociacao?${params.join('&')}`)
                    .then(({ data }) => {
                        this.model = data;
                        if (data.lista.length == 0 && this.page > 1) {
                            this.page = 1
                            this.loadAsyncData()
                        }
                        this.total = this.perPage * data.pageCount;
                        this.loading = false;
                        this.$router.replace({query: {procurar: this.procurar, page: this.page }});
                                                          
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    }).finally(() => {                        
                        this.clienteId = null;
                    }); 
                                       
            }, 500),

            montaParametros(){
                const params = [                                        
                    `unidadeId=${this.unidadeId}`,                                        
                    `page=${this.page}`,
                    `oportunidadesInside=true`              
                ];


                if (this.procurar != null && this.procurar.length>=3) {                    
                    params.push(`nome=${this.procurar}`);                    
                }
          
                if (this.clienteId != null) 
                    params.push(`clienteId=${this.clienteId}`);
                
        
                if (this.codigoExterno != null) 
                    params.push(`codigoExterno=${this.codigoExterno}`);          
                                
                                
                if (this.vendedorFiltro !=null){
                    params.push(`comercialId=${this.vendedorFiltro}`);
                }

                if (this.temperaturaFiltro !=null){
                    params.push(`temperatura=${this.temperaturaFiltro}`);
                }                

                return params;
            }  ,         
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPorVistoria=null;
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
  
              
            carregarVendedoresUnidade(){


                this.$http.get('/api/search/FuncionarioComercial')
                .then(res => res.data)
                .then(data => {
                    if (data != null) {
                        this.listaVendedoresUnidade = data;
                    }
                });
                

            }            

                        
        },

            
        async mounted() {            
            await this.carregarVendedoresUnidade();                     
            await this.loadAsyncData();
            
        }
    }
</script>